<template>
    <div class="solution-main">
         <!-- 头部 -->
      <headers></headers>
        <section class="ban ban4">
            <div class="col">
                <div>
                    <h1 class="title1">场馆解决方案</h1>
                    <p>为会展场馆提供多元化、个性化、高性价比的数字化管理解决方案。</p>
                </div>
            </div>
        </section>
        <div style="">
            <section class="col box-3" style="padding-top: 50px;">
                <h4 class="title3" style="margin-bottom: 30px;">核心优势</h4>
                <div class="list-hxys">
                    <dl>
                        <dt>智慧云管理</dt>
                        <dd>⼀站式数字化管理<br>
                            整体架构灵活多变<br>
                            业务流程专业智能<br>
                            ⾼效内部协同办公</dd>
                    </dl>
                    <dl>
                        <dt>安全高效</dt>
                        <dd>严格的权限划分<br>
                            规范的流程设置<br>
                            灵活的模块组合<br>
                            安全的云端存储</dd>
                    </dl>
                    <dl>
                        <dt>专业服务</dt>
                        <dd>先进的运营理念<br>
                            专业的运营经验<br>
                            专业的研发团队<br>
                            一对一服务护航</dd>
                    </dl>
                </div>
            </section>
            <section class="col box-3" style="">
                <h4 class="title3" style="margin-bottom: 70px;">应用场景</h4>
                <div class="box-yycj-4">
                    <div class="t1">功能⾃由组合</div>
                    <p class="p1">场馆销售、现场管理、智慧巡查、⾃办展会、物流管控、特装业务等功能</p>
                    <div class="d1">
                        <img class="img1" src="../images/img-3-8.png" alt="">
                    </div>
                </div>
                


            </section>

            <section class="col box-3">
                <h4 class="title3" style="margin-bottom: 50px;">合作伙伴</h4>
                <ul class="brand-list">
                    <li><img src="../images/logo/36中食.jpg" alt=""></li>
                    <li><img src="../images/logo/37饲料.jpg" alt=""></li>
                    <li><img src="../images/logo/38餐饮.jpg" alt=""></li>
                    <li><img src="../images/logo/39零售.jpg" alt=""></li>
                    <li><img src="../images/logo/40特许加盟.jpg" alt=""></li>
                    <li><img src="../images/logo/41集约化畜牧.jpg" alt=""></li>
                    <li><img src="../images/logo/42畜牧.jpg" alt=""></li>
                    <li><img src="../images/logo/43成都健身.jpg" alt=""></li>
                    <li><img src="../images/logo/44混凝土.jpg" alt=""></li>
                    <li><img src="../images/logo/45烘培.jpg" alt=""></li>
                    <li><img src="../images/logo/46成都广告.jpg" alt=""></li>
                    <li><img src="../images/logo/47成都幼教.jpg" alt=""></li>
                </ul>
            </section>
        </div>
        <h4 class="title3" style="margin-bottom: 30px;margin-top: 100px;font-size: 26px;">服务联系</h4>
        <div class="box-fwlx">
            <section class="col box-3 ">
                <div class="box-fwlx-con">
                    <div class="div1">
                        <p>企微客服</p>
                        <img src="../images/img-kf.png" alt="">
                        <p>首席客服热线</p>
                        <span>010-86460766-861</span>
                    </div>
                    
                        <ul class="ul1">
                            <form id="form-zx2" action="">
                                <li class="li1">
                                    <label for="">公司名称</label>
                                    <input name="compnay" type="text" maxlength="50">
                                </li>
                                <li class="li1">
                                    <label for="">所在行业</label>
                                    <input name="industry" type="text" maxlength="30">
                                </li>
                                <li class="li1">
                                    <label for="">您的姓名</label>
                                    <input name="username" type="text" maxlength="20">
                                </li>
                                <li class="li1">
                                    <label for="">手机号码</label>
                                    <input name="phone" type="text">
                                </li>
                                <li>
                                    <label for="">咨询需求</label>
                                    <textarea name="content" id="" maxlength="200"></textarea>
                                </li>
                                <li>
                                    <a class="btn" id="btn-zx-sub2" href="javascript:;">立即发送</a>
                                </li>
                            </form>
                        </ul>
                    
                </div>
            </section>
        </div>
        <!-- 尾部 -->
      <footers></footers>
      <!-- 右侧吸附客服咨询按钮 -->
      <contact></contact>
    </div>
    </template>
    <script>
    import $ from 'jquery';
    import headers from '@/common/header';
    import footers from '@/common/Footer';
    import contact from '@/components/contact';
    export default {
        components: {
            headers,
            footers,
            contact
        },
        data() {
            return {
            }
        },
    }
    </script>



// WEBPACK FOOTER //
// src/page/solution-4.vue